import { NotesBox } from "@components/LNotesBox";
import { Note } from "@store/generalTypes";
import { AssessmentNotes } from "./assessmentNotes";

export const NotesSection = ({ notes }: NotesSectionProps): JSX.Element => {
    return (
        <NotesBox title={`Notes (${notes.length})`}>
            <AssessmentNotes notes={notes} />
        </NotesBox>
    );
};

interface NotesSectionProps {
    notes: Note[];
}
